namespace pixi_ui.utility {
    import DefaultBuilder = pixi_ui.utility.DefaultBuilder;
    import IBuilder = pixi_ui.utility.IBuilder;

    export class UIFactory {
        public static createUI(data: any, driver?: IBuilder): Element {
            let builder: IBuilder = driver || new DefaultBuilder();
            let rootElement: Element = builder.create(data);
            return rootElement;
        }
    }
}
